<template>
  <div class="content--sinoreg Protocolos">
    <header-blue>
      <h4>Protocolos</h4>
    </header-blue>

    <router-view />
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"

  export default {
    name: "Protocolos",
    components: {
      HeaderBlue
    }
  }
</script>

<style lang="scss">
  .Protocolos {
    &_table {
      &--header {
        background-color: #01bfa5;
      }
      &--row {
        cursor: pointer;
      }
    }
  }
</style>
